<template>
	<div class="container">

		<div class="row justify-content-center">
			<div class="col-lg-8 col-xl-5 text-center mt-4">
				<form class="d-flex justify-content-center" @submit.prevent="gallerySearch" v-if="gallery.elements.length">
						<input type="text" class="form-control form-control-lg mb-2 mr-1 mr-md-2" id="search" placeholder="Cerca la tua scuola" v-model="gallery.search">
						<button type="submit" class="btn btn-yellow rounded-pill px-3 py-0 mb-2"><span class="va-sub">CERCA</span></button>
				</form>
			</div>
		</div>

		<div id="gallery-container" class="row pt-5 justify-content-center" v-if="gallery.elements.length">
			<div class="col-sm-10 col-md-6 col-xl-4 mb-4" v-for="(elm, index) in gallery.elements" :key="index">

				<div class="row">
					<div class="col-12">
						<div class="vid-container" :style="{backgroundImage: 'url(' + themeUrl + 'img/' + elm.sfondo + ')'}">
							<div
								class="vid-inner w-100 text-center text-white bold font-grandstander"
								:class="{
									'fs-2-4': (elm.text.length <= 50),
									'fs-1-9': (elm.text.length > 50 && elm.text.length <= 100),
									'fs-1-6': (elm.text.length > 100)
								}"
								v-html="elm.text"
							></div>

							<div class="camera" @click.prevent="showWork(elm.media_html, elm.text)" v-if="elm.id_media > 0 && elm.appr_media == 1">
								<img :src="themeUrl + '/img/camera.png'" alt="" class="img-fluid">
							</div>
						</div>
					</div>
					<div class="col-12 mt-3">
						<p class="wrk-school text-center mb-0 bold">Scuola {{elm.nome}}</p>
					</div>
					<div class="col-12">
						<p class="wrk-class text-center mb-0 bold">
							<span v-if="elm.classe != 0">{{elm.classe}}{{elm.sezione}}</span>
							<span v-else>{{elm.sezione}}</span>
						</p>
						<p class="text-center fs-0-8">
							<span class="">{{elm.citta}}</span>
						</p>
					</div>
				</div>

			</div>
		</div>

		<div id="gallery-container" class="row pt-5 justify-content-center mb-5" v-else>
			<div class="col-sm-10 text-center" v-if="gallery.search == ''">
				<p class="fs-2">Le classi stanno ancora lavorando ai propri contributi.</p>
			</div>
			<div class="col-sm-10 text-center" v-else>
				<p class="fs-2" >Non ci sono contributi che corrispondono alla ricerca effettuata.</p>
				<button class="btn btn-yellow rounded-pill px-5 py-0 mt-2" @click.prevent="onResetSearch">
					<span class="va-sub">RESET</span>
				</button>
			</div>
		</div>

		<div class="row">
			<div class="col-12 text-center my-4">
				<button class="btn btn-yellow rounded-pill px-4 py-0" v-if="!gallery.isEnd"><span class="va-sub" @click="loadMore">MOSTRA DI PIÙ</span> <i class="fas fa-circle-notch fa-spin va-sub fs-1-2 ml-1" :class="{'d-none': !isLoading}"></i></button>
			</div>
		</div>

		<modal name="gallery-modal"
			height="auto"
			:adaptive="false"
			:width="maxModalWidth"
			:scrollable="true"
			id="gallery-modal"
		>

			<div class="modal-header text-right bg-transparent p-0">
				<button type="button" class="close px-0 py-2" data-dismiss="modal" aria-label="Close" @click.prevent="$modal.hide('gallery-modal')">
					<svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" fill="#ffffff" class="bi bi-x" viewBox="0 0 16 16">
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
					</svg>
				</button>
			</div>
			<div class="img-modal p-0 m-0" v-html="modal.img"></div>
			<div class="text-center bg-yellow">
				<div class="py-4 px-3 text-white bold fs-1-5 font-grandstander" v-html="modal.text"></div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import { urlBase, themeDir } from '../../variables.js'

export default {
	name: 'GalleryComponent',

	data() {
		return {
			ajaxObj: window.ajax_object,
			themeUrl: '',
			bgUrl: '',
			gallery: {
				xpage: '3',
				pageNo: 1,
				search: '',
				elements: [],
				isEnd: false
			},
			modal: {
				img: '',
				text: ''
			},
			isLoading: false,
			maxModalWidth: window.outerWidth <= 650 ? (window.outerWidth - 8) : 650
		}
	},

	methods: {
		getGalleryElements() {
			this.isLoading = true
			let url = this.ajaxObj.ajax_url

			let data = new FormData();
			data.append('action', 'nl_get_works')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('xpage', this.gallery.xpage)
			data.append('current_page', this.gallery.pageNo)
			data.append('search', this.gallery.search)

			axios.post(url, data)
				.then((response) => {
					console.log(response.data)
					if (response.data.gallery_elements.length) {
						this.gallery.elements = this.gallery.elements.concat(response.data.gallery_elements)
					}
					this.isLoading = false
					this.gallery.isEnd = response.data.disable_btn == 1 ? true : false
				}, (error) => {
					this.isLoading = false
					console.log(error);
				});
		},

		gallerySearch() {
			this.gallery.elements = []
			this.getGalleryElements()
		},

		onResetSearch() {
			this.gallery.search = ''
			this.gallerySearch()
		},

		loadMore() {
			this.gallery.pageNo = this.gallery.pageNo + 1
			this.getGalleryElements()
		},

		showWork(html, text) {
			this.modal.img = ''
			this.modal.text = ''
			this.modal.img = html
			this.modal.text = text
			this.$modal.show('gallery-modal')
		}
	},

	mounted() {
		this.themeUrl = urlBase + themeDir
		this.getGalleryElements()
	}

}
</script>

<style scoped>
.vid-container {
	width: 100%;
	padding-top: 100%;
	position: relative;
	background-color: transparent;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
}
.vid-inner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 1% 5%;
}
.camera {
	position: absolute;
	max-width: 64px;
	bottom: 15px;
	right: 15px;
	cursor: pointer;
}
</style>
